import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_RUN_PHI_AUDIT_BEGIN,
  COLLECTIONS_RUN_PHI_AUDIT_SUCCESS,
  COLLECTIONS_RUN_PHI_AUDIT_FAILURE,
  COLLECTIONS_RUN_PHI_AUDIT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function runCollectionPHIAudit(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_RUN_PHI_AUDIT_BEGIN,
    });
    const { projectId, version, collectionName } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/phi-audit/collection`,
        { collectionName },
        header,
      );
      doRequest.then(
        (res) => {
          if (res.data && res.data.code === 200) {
            dispatch({
              type: COLLECTIONS_RUN_PHI_AUDIT_SUCCESS,
              data: res.data,
            });
            Mixpanel.track(`PHI Audit Done for collection ${collectionName} `);
            toast.success(res.data.message);
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_RUN_PHI_AUDIT_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track(`Failed to do PHI Audit for ${collectionName}`);
            toast.error(`Failed to do PHI Audit for ${collectionName}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_RUN_PHI_AUDIT_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to do PHI Audit for ', { collectionName });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'PHI Audit Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissRunCollectionPHIAuditError() {
  return {
    type: COLLECTIONS_RUN_PHI_AUDIT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_RUN_PHI_AUDIT_BEGIN:
      return {
        ...state,
        runCollectionPHIAuditPending: true,
        runCollectionPHIAuditError: null,
      };

    case COLLECTIONS_RUN_PHI_AUDIT_SUCCESS:
      return {
        ...state,
        runCollectionPHIAuditPending: false,
        runCollectionPHIAuditError: null,
      };

    case COLLECTIONS_RUN_PHI_AUDIT_FAILURE:
      return {
        ...state,
        runCollectionPHIAuditPending: false,
        runCollectionPHIAuditError: action.data.error,
      };

    case COLLECTIONS_RUN_PHI_AUDIT_DISMISS_ERROR:
      return {
        ...state,
        runCollectionPHIAuditError: null,
      };

    default:
      return state;
  }
}
